<script setup lang="ts">
import { onIonViewWillEnter, useIonRouter } from "@ionic/vue";
import { logIn } from "ionicons/icons";
import {
  IonLabel,
  IonLoading,
  IonItem,
  IonInput,
  IonButton,
  IonPage,
  IonNote,
  IonContent,
  IonIcon,
} from "@ionic/vue";
import { reactive } from "vue";
import { useMyAccount } from "../";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";

const router = useIonRouter();
const { isMobile } = useWindowWidth();

const { loginForm } = useMyAccount();

const state = reactive({
  loading: false,
  errorMessage: "",
});

const userStore = useUserStore();

onIonViewWillEnter(() => {
  userStore.setUserLogout();
});

const login = async () => {
  state.loading = true;
  userStore
    .login({
      username: loginForm.email,
      password: loginForm.password,
    })
    .then(async () => {
      gtag_event("login", {
        category: "check-in app",
        label: "Login successfully",
      });
      await userStore.fetchMe();
      await userStore.fetchRoles();
      state.loading = false;

      const { events } = userStore.related;
      if (!userStore.userIsAdmin) {
        if (events && events.length === 1) {
          router.push(`/event/${userStore.related.events[0].id}/home`);
        } else if (events && events.length > 1) {
          router.push("/home");
        } else {
          router.push("/onboarding/new-event");
        }
      } else {
        router.push("/home");
      }
    })
    .catch(() => {
      state.loading = false;
      state.errorMessage = "Your email or password are incorrect";
    });
};
</script>

<template>
  <ion-page>
    <ion-content>
      <div v-if="!isMobile" class="background-image"></div>
      <div class="login-container">
        <img v-if="isMobile" src="@/assets/background.png" />
        <section :style="isMobile ? '' : 'text-align: center;'">
          <div :class="{ container: !isMobile }">
            <div :class="{ container: isMobile }">
              <h1>It's time to stir things up</h1>
              <p>Support a fast and efficient check-in process.</p>
            </div>
            <div :style="isMobile ? '' : 'max-width: 600px; margin: 0 auto'">
              <ion-item>
                <ion-label position="stacked">Email</ion-label>
                <ion-input
                  v-model="loginForm.email"
                  name="email"
                  placeholder="john.doe@email.com"
                  type="email"
                ></ion-input>
              </ion-item>
              <ion-item :class="{ 'ion-invalid': state.errorMessage !== '' }">
                <ion-label position="stacked"> Password</ion-label>
                <ion-input
                  name="password"
                  v-model="loginForm.password"
                  type="password"
                  placeholder="******"
                >
                </ion-input>
                <ion-note slot="error" v-if="state.errorMessage !== ''">{{
                  state.errorMessage
                }}</ion-note>
              </ion-item>
              <div v-if="!isMobile" style="text-align: left; margin-top: 30px">
                <router-link :to="`/reset-password`"
                  >Forgot password?</router-link
                >

                <ion-button
                  expand="block"
                  color="primary"
                  @click="login()"
                  class="ion-margin-top login-button"
                >
                  <ion-icon slot="start" :icon="logIn"></ion-icon>
                  Login
                </ion-button>

                <p class="ion-margin-top ion-text-center">
                  No account yet?
                  <router-link :to="`/onboarding/introduction`"
                    >Sign up.</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </section>
        <div v-if="isMobile" class="container">
          <section>
            <router-link :to="`/reset-password`">Forgot password?</router-link>

            <ion-button
              expand="block"
              color="primary"
              @click="login()"
              class="ion-margin-top login-button"
            >
              <ion-icon slot="start" :icon="logIn"></ion-icon>
              Login
            </ion-button>

            <p class="ion-margin-top ion-text-center">
              No account yet?
              <router-link :to="`/onboarding/introduction`"
                >Sign up.</router-link
              >
            </p>
            <!-- <hr /> -->
            <!-- <p class="ion-text-center">or register with</p>
          <ion-grid>
            <ion-row style="width: 13rem; margin: 0 auto">
              <ion-col size="4">
                <ion-button expand="block" shape="round" style="padding: 0">
                  <ion-icon :icon="logoGoogle"></ion-icon>
                </ion-button>
              </ion-col>
              <ion-col size="4">
                <ion-button expand="block" shape="round" style="padding: 0">
                  <ion-icon :icon="logoFacebook"></ion-icon>
                </ion-button>
              </ion-col>
              <ion-col size="4">
                <ion-button expand="block" shape="round" style="padding: 0">
                  <ion-icon :icon="logoLinkedin"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid> -->
          </section>
        </div>
      </div>
    </ion-content>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </ion-page>
</template>

<style lang="scss" scoped>
.button {
  --padding-start: 0;
  --padding-end: 0;
}

.background-image {
  height: 100vh;
  width: 100%;
  background-image: url("@/assets/background.png");
  background-size: cover;
}

@media (min-width: 768px) {
  .container {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    transform: translate(-50%, -50%);
  }
  .login-container {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
  }
}
</style>
